import React, { useState } from 'react';
import { SettingCard } from '../../components/SettingCards/SettingCard/SettingCard';
import { RadioSetting } from '../../components/SettingCards/RadioSetting/RadioSetting';
import { PrimaryButton } from '../../components/Buttons/Buttons';
import { ButtonGroup } from '../../components/Buttons/ButtonGroup/ButtonGroup';
import { COLLECT_LOGS_SETTING_IDS } from '../../config/SettingIds';
import { getSettingConfig, RadioSettingConfig } from '../../config/SettingsDefinitions';
import { LogCollectionDialog } from './LogCollectionDialog';
import { LogFileCard } from './LogFileCard';
import { useLogCollection } from './useLogCollection';
import {
	LOG_COLLECTION_STRINGS,
	LOG_COLLECTION_SETTING_STRINGS,
} from '../../pages/SupportAndTroubleshoot/SupportAndTroubleshootStrings';
import './LogCollectionSetting.css';

export const LogCollectionSetting: React.FC = () => {
	const [logLevel, setLogLevel] = useState('medium');
	const {
		dialogMode,
		logFile,
		handleStartCollecting,
		handleCollectExisting,
		handleStop,
		handleCancel,
		handleDownload,
		handleDelete,
	} = useLogCollection();

	const handleLevelChange = (value: string) => {
		setLogLevel(value);
	};

	const config = getSettingConfig(
		COLLECT_LOGS_SETTING_IDS.LOG_COLLECTION
	) as RadioSettingConfig;
	const options = config?.options || [];

	return (
		<>
			<SettingCard
				settingId={COLLECT_LOGS_SETTING_IDS.LOG_COLLECTION}
				title={LOG_COLLECTION_SETTING_STRINGS.SELECT_LOG_LEVEL}
				description={LOG_COLLECTION_SETTING_STRINGS.SELECT_LOG_LEVEL_DESCRIPTION}
				content={
					<>
						<RadioSetting
							card={false}
							settingId={COLLECT_LOGS_SETTING_IDS.LOG_COLLECTION}
							title=""
							options={options}
							selectedValue={logLevel}
							onChange={handleLevelChange}
						/>
						<div className="log-collection-actions">
							<p className="log-collection-actions-description">
								Select the log level and then choose to either{' '}
								<strong>{LOG_COLLECTION_STRINGS.START_COLLECTING_LOGS}</strong> to
								reproduce the issue, or select{' '}
								<strong>{LOG_COLLECTION_STRINGS.COLLECT_EXISTING_LOGS}</strong> if you
								can&apos;t reproduce the issue.
							</p>
							<ButtonGroup>
								<PrimaryButton
									onClick={() => handleStartCollecting(logLevel)}
									ariaLabel={LOG_COLLECTION_STRINGS.START_COLLECTING_LOGS}
								>
									{LOG_COLLECTION_STRINGS.START_COLLECTING_LOGS}
								</PrimaryButton>
								<PrimaryButton
									onClick={handleCollectExisting}
									ariaLabel={LOG_COLLECTION_STRINGS.COLLECT_EXISTING_LOGS}
								>
									{LOG_COLLECTION_STRINGS.COLLECT_EXISTING_LOGS}
								</PrimaryButton>
							</ButtonGroup>
						</div>
						{logFile && (
							<LogFileCard
								logFile={logFile}
								allowDownloadFile={true}
								onDownload={handleDownload}
								onDelete={handleDelete}
							/>
						)}
					</>
				}
			/>
			<LogCollectionDialog
				isOpen={dialogMode !== null}
				mode={dialogMode}
				onStop={handleStop}
				onCancel={handleCancel}
			/>
		</>
	);
};
